import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import AgilysysLogo from '../components/AgilysysLogo';
import { DiningRoomIcon, CafeIcon, KitchenIcon } from '../components/AreaIcons';
import greenTouchIcon from '../assets/green-touch-icon.gif';

const DiningPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page splash2 diningPage">
      <Header />
      <div className="page-header">On Site Dining</div>

      <div className="text-blocks">
        <div className="std-text">
          {"Use InfoGenesis Meal Plan Integration to offer your residents the convenience of cashless tender. Create unique accounts for residents, employees, resident account charge or any other type of charge."}
        </div>
        <div className="std-text">
          {"Establish multiple types of Meal Plan accounts for resident and staff through gift cards, payroll deductions, stored value and VIP cards."}
        </div>
      </div>

      <div className="tap">
        <img
          src={greenTouchIcon}
          alt="Tap to explore"
        />
        <div className="tap-prompt">{"Tap on each section of the map\nTo drill into the details"}</div>
      </div>

      <div className="logo" onClick={() => navigate('/aboutus/agilysys')}>
        <AgilysysLogo />
      </div>

      <div className="dining-map">
        <div className="dining-room">
          <DiningRoomIcon onClick={() => navigate('/dining/dining-room')} />
        </div>
        <div className="kitchen">
          <KitchenIcon onClick={() => navigate('/dining/kitchen')} />
        </div>
        <div className="cafe">
          <CafeIcon onClick={() => navigate('/dining/cafe')} />
        </div>
      </div>
    </div>
  );
};

export default DiningPage;
